export default {
      id: "alert-icon-success-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "svg-sprite-defs.svg#alert-icon-success",
      toString: function () {
        return this.url;
      }
    }